<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-center">Fecha Solicitud</th>
              <th scope="col" class="text-center">Afiche/Banner</th>
              <th scope="col" class="text-center">Convocatoria</th>
              <th scope="col" class="text-center">Evento</th>
              <th scope="col" class="text-center">Solicitante/unidad</th>
              <th scope="col" class="text-center">Información</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedItems" :key="item.id">
              <!-- <th scope="row">{{ item.id }}</th> -->
              <th scope="row" class="text-center">
                {{ (currentPage - 1) * itemsPerPage + index + 1 }}
              </th>
              <td class="text-center">{{ formatDate(item.received_at) }}</td>
              <td class="text-center">
                <div
                  class="btn-group btn-sm"
                  role="group"
                  aria-label="Basic example"
                >
                  <button
                    class="btn btn-secondary btn-sm"
                    type="button"
                    @click="viewImage(item, 'Afiche', 'poster')"
                    title="Ver Afiche"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                  <button
                    class="btn btn-success btn-sm"
                    type="button"
                    @click="viewImage(item, 'Banner', 'banner')"
                    title="Ver Banner"
                  >
                    <i class="fa fa-eye"></i>
                  </button>
                </div>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-primary btn-sm"
                  type="button"
                  @click="openReglamento(item, 'Regulation', 'regulation')"
                  title="Ver convocatoria en PDF"
                >
                  <i class="fa fa-eye"></i>
                </button>
              </td>
              <td class="text-center" style="max-width: 250px">
                {{ item.title }}
              </td>
              <td class="text-center">
                <div style="font-weight: bold; padding: 0">
                  {{ item.user }}
                </div>
                <div style="padding: 0">
                  {{ item.unity }}
                </div>
              </td>
              <td class="text-center">
                <button
                  class="btn btn-info btn-sm"
                  type="button"
                  @click="showEventInfo(item)"
                  title="Ver información del evento"
                >
                  <i class="fa fa-info-circle"></i><br />
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <pagination
        :totalItems="list.length"
        :itemsPerPage="itemsPerPage"
        @page-change="handlePageChange"
      />
    </div>
  </div>
  <EventInfoModal ref="eventInfoModal" :event="selectedEventInfo" />
  <PdfViewModal ref="pdfModal" :event="selectedEventInfo" source="regulation" />
  <ViewImageModal
    ref="viewImageModal"
    :event="selectedEvent"
    :name="modalName"
    :mode="modalMode"
  />
</template>
<script setup>
import { onMounted, ref, inject, computed } from "vue";
import axios from "@/includes/connection";
import EventInfoModal from "@/pages/inbox/components/EventInfoModal.vue";
import ViewImageModal from "./ViewImageModal.vue";
import PdfViewModal from "@/pages/inbox/components/PreviewPdfModal.vue";

import Pagination from "@/pages/components/Pagination.vue";

let list = ref([]);
let eventInfoModal = ref(null);
let viewImageModal = ref(null);

const selectedEventInfo = ref({});
const selectedEvent = ref({});
const modalName = ref("");
const modalMode = ref("");
let pdfModal = ref(null);

const sortedList = computed(() => {
  return [...list.value].sort((a, b) => {
    return new Date(b.updated_at) - new Date(a.updated_at);
  });
});

onMounted(() => {
  loadItems();
});

function formatDate(dateString) {
  const date = new Date(dateString);
  return new Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(date);
}
function showEventInfo(event) {
  //console.log("Informacion del evento a revisar:", event);
  selectedEventInfo.value = event;
  eventInfoModal.value.show();
}

function openReglamento(item) {
  selectedEventInfo.value = item;
  pdfModal.value.show();
}

function viewImage(event, name, mode) {
  selectedEvent.value = event;
  modalName.value = name;
  modalMode.value = mode;
  viewImageModal.value.show();
}

function loadItems() {
  axios
    .get("/event/published")
    .then((response) => {
      //console.log("list users", response.data);
      if (response.data) {
        list.value = response.data;
      }
    })
    .catch(function (error) {
      console.log(error);
    });
}
async function changeStatus(eventCode) {
  let options = this.recive;
  if (eventCode.inbox > 1) {
    options = this.accion;
  }
  const { value: action } = await this.$swal.fire({
    title: "Acción a Realizar",
    input: "select",
    inputOptions: options,
    inputPlaceholder: "Seleccione Accion",
    showCancelButton: true,
    inputValidator: (value) => {
      return new Promise((resolve) => {
        resolve();
      });
    },
  });
  if (action) {
    const dataJson = {
      event_id: eventCode.id,
      step_id: 1,
      action_id: action,
      state: 1,
    };
    this.$axios
      .post("/flow-event", dataJson)
      .then((response) => {
        console.log("response", response);
        this.loadItems();
        this.$swal.fire({
          title: "Registro Exitoso!!!",
          icon: "success",
        });
      })
      .catch(function (error) {
        this.$swal.fire({
          title: "Registro fallido!!!",
          icon: "warning",
        });
      });
  }
}

let currentPage = ref(1);
let itemsPerPage = ref(10);

let paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  //return list.value.slice(startIndex, endIndex);
  return sortedList.value.slice(startIndex, endIndex);
});

function handlePageChange(page) {
  currentPage.value = page;
}
</script>
